import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DeletePinInputClass;
function DeletePinInput() {
  if (DeletePinInputClass === VOID) {
    class $ {
      constructor(partyId, pinId) {
        this.b6p_1 = partyId;
        this.c6p_1 = pinId;
      }
      toString() {
        return 'DeletePinInput(partyId=' + this.b6p_1.toString() + ', pinId=' + this.c6p_1.toString() + ')';
      }
      hashCode() {
        var result = this.b6p_1.hashCode();
        result = imul(result, 31) + this.c6p_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DeletePinInput()))
          return false;
        if (!this.b6p_1.equals(other.b6p_1))
          return false;
        if (!this.c6p_1.equals(other.c6p_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DeletePinInput');
    DeletePinInputClass = $;
  }
  return DeletePinInputClass;
}
//region block: exports
export {
  DeletePinInput as DeletePinInputmel7ixrs09hz,
};
//endregion

//# sourceMappingURL=DeletePinInput.mjs.map
